import React from 'react';
import { Link } from 'react-router-dom';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import '../../css/common/EventCard.css';

const EventCard = ({ title, date, location, description, imageUrl, link, index }) => {
  return (
    <div className="event-card-component">
      <div className="event-card-image-container">
        <img src={imageUrl} alt={title} />
      </div>
      <div className="event-card-content">
        <h3 className="event-card-title">{title}</h3>
        <div className="event-card-info">
          <CalendarTodayIcon fontSize="small" />
          {date}
        </div>
        <div className="event-card-info">
          <LocationOnIcon fontSize="small" />
          {location}
        </div>
        <p className="event-card-description">{description}</p>
        <Link to={link} className="event-card-read-more">Learn More →</Link>
      </div>
    </div>
  );
};

export default EventCard; 